
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage, getCurrentLanguage, SUPPORTED_LANGS } from './i18n';
import { getToken, setToken } from './App';

const LANG_LABELS = {
    es: 'ES',
    ca: 'CA',
    en: 'EN',
};

const LANG_FULL = {
    es: 'Español',
    ca: 'Català',
    en: 'English',
};

function LanguageSelector({ user }) {
    const { t } = useTranslation();
    const [current, setCurrent] = useState(getCurrentLanguage());
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const handler = () => setCurrent(getCurrentLanguage());
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }, []);

    const handleChange = async (e) => {
        const newLang = e.target.value;
        setSaving(true);
        try {
            await changeLanguage(newLang);
            setCurrent(newLang);

            const token = getToken();
            const stored = localStorage.getItem('nexus_user');
            if (token && stored) {
                try {
                    const res = await fetch('/api/me', {
                        method: 'PATCH',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ preferred_language: newLang }),
                    });
                    if (res.ok) {
                        const data = await res.json();
                        if (data.token) setToken(data.token);
                        if (data.user) {
                            localStorage.setItem('nexus_user', JSON.stringify(data.user));
                        }
                    }
                } catch (err) {
                    console.warn('No se pudo persistir preferred_language en el perfil:', err.message);
                }
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="lang-wrap" title={t('language.selector_title')}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
            >
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z" />
            </svg>
            <select
                value={current}
                onChange={handleChange}
                disabled={saving}
                className="lang-selector"
                title={t('language.selector_title')}
                aria-label={t('language.selector_title')}
            >
                {SUPPORTED_LANGS.map((lang) => (
                    <option key={lang} value={lang} title={LANG_FULL[lang]}>
                        {LANG_LABELS[lang]}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default LanguageSelector;
